import PageWrapper from "app/components/PageWrapper";
import AbsenseReasonsTable from "./AbsenseReasonsTable";
import { ServerSidePaginationContextProvider } from "shared/contexts/ServerSidePaginationContext";
const AbsenseReasons = () => {
    return (
        <PageWrapper
            title="Absense Reasons"
            menuOptions={[{ children: "Admin", to: "/admin" }]}
        >
            <ServerSidePaginationContextProvider>
            <AbsenseReasonsTable />
            </ServerSidePaginationContextProvider>
        </PageWrapper>
    );
};

export default AbsenseReasons;
